import React from 'react';
import ReactDOM from 'react-dom';
import superagent from 'superagent';

import {Form, FormControl, FormGroup, ControlLabel, Button, Col, PageHeader, Panel, Table} from 'react-bootstrap';
import styles from './LoginForm.css';
import { LoggedUserName, LoggedUserEmail, LoggedUserJazyk, LoggedUserId } from './Login';
import InfoMsg  from '../../api/InfoMsg';

import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
 en:{
   h2:"User info",
   jmeno:"Name",
   email:"E-mail",
   jazyk:"Language",
   button:"Save"
 },
 cs: {
   h2:"Informace o uživateli",
   email:"E-mail",
   jmeno:"Jméno",
   jazyk:"Jazyk",
   button:"Uložit"
 }
});

export class UserDetailOsoba extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      userName: LoggedUserName(),
      UserEmail: LoggedUserEmail(),
      userJazyk: LoggedUserJazyk(),
      errorMessage: '', infoMsgStyle:"info",
      lekce: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount = () => {
    var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_user_info.php?userid=' + LoggedUserId() + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({lekce: myObject.lekce});
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    superagent.post('https://rezervace.copasedeje.cz/servis/_users_change.php').
      send("id="+LoggedUserId()).
      send("jmeno="+ReactDOM.findDOMNode(this.refs.JmenoInput).value).
      send("email="+ReactDOM.findDOMNode(this.refs.EmailInput).value).
      send("jazyk="+ReactDOM.findDOMNode(this.refs.JazykInput).value).
      then(res => {
        var myObject = JSON.parse(res.text);
        if (myObject.error == '') {
          this.setState({infoMsgStyle: 'info'});
          window.sessionStorage.setItem("userID", myObject.id);
          window.sessionStorage.setItem("userName", myObject.popis);
          window.sessionStorage.setItem("userEmail", myObject.email);
          window.sessionStorage.setItem("userJazyk", myObject.jazyk);
          window.sessionStorage.setItem("opravneni", myObject.opravneni);
          //window.location.reload();
          this.props.setUser(myObject.id,myObject.popis);
          if (LoggedUserJazyk() == 'cs') {
            this.setState({errorMessage: myObject.msg});
          } else {
            this.setState({errorMessage: myObject.msg_en});
          }
        } else {
          this.setState({infoMsgStyle: 'danger'});
          if (LoggedUserJazyk() == 'cs') {
            this.setState({errorMessage: myObject.error});
          } else {
            this.setState({errorMessage: myObject.error});
          }
        }
      });

    return false;
  }

  handleChange(value) {
    this.setState({errorMessage: ''});
  }

  render() {
    strings.setLanguage(LoggedUserJazyk());
    let Item1;
    let Item2;
    if (LoggedUserJazyk() != 'cs') {
      Item1 = <option value="cs">česky</option>;
      Item2 = <option value="en" selected>english</option>;
    } else {
      Item1 = <option value="cs" selected>česky</option>;
      Item2 = <option value="en">english</option>;
    }

    return (
      <div>
        <h2 className={styles.uvodH2}><i className={"fa fa-user " + styles.panelHeaderFa}></i> {strings.h2}</h2>
        <div id="uvod_ubytovani" className={styles.panelHome + " card"}>
          <InfoMsg styleBS={this.state.infoMsgStyle} text={this.state.errorMessage}/>
          <Form horizontal className={styles.form} onSubmit={this.handleSubmit} id="form_registrace">
            <FormGroup>
              <Col componentClass={ControlLabel} sm={3}>{strings.jmeno}:</Col>
              <Col sm={5}><FormControl type="text" placeholder={strings.jmeno} ref="JmenoInput" name="JmenoInput" defaultValue={this.state.userName} onChange={this.handleChange} required /></Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={3}>{strings.email}:</Col>
              <Col sm={5}><FormControl type="email" placeholder={strings.email} ref="EmailInput" name="EmailInput" defaultValue={this.state.UserEmail} onChange={this.handleChange} required /></Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={3}>Zaplacené lekce:</Col>
              <Col sm={2}><FormControl type="email" ref="LekceInput" name="LekceInput" value={this.state.lekce} disabled /></Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={3}>{strings.jazyk}:</Col>
              <Col sm={5}>
                <FormControl disabled componentClass="select" placeholder="select" ref="JazykInput" defaultValue={this.state.userJazyk} onChange={this.handleChange} >
                  Item1 = <option value="cs">česky</option>;
                  Item2 = <option value="en">english</option>;
                </FormControl>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={3}></Col>
              <Col sm={9}><Button bsStyle="success" type="submit" >{strings.button}</Button></Col>
            </FormGroup>
          </Form>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// src/components/login/UserDetailOsoba.jsx